import { Typography } from "@mindlercare/ui-web";

export const InfoMessage = ({ infoMessage }: { infoMessage: string }) => {
  if (!infoMessage) return null;

  return (
    <div
      style={{
        marginTop: "4px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        variant="body-x-small"
        color="BLACK_GREY"
        sx={{
          marginLeft: "4px",
        }}
      >
        {infoMessage}
      </Typography>
    </div>
  );
};
